import React from "react";
import { Box, Group, Text, Anchor, Flex, useMantineTheme } from "@mantine/core";
import { IconMail, IconWorld } from "@tabler/icons-react";

const Footer: React.FC = () => {
  const theme = useMantineTheme(); // Access the theme object here

  return (
    <Box
      sx={{
        padding: theme.spacing.md,
        borderTop: `1px solid ${theme.colors.gray[3]}`,
        backgroundColor: theme.colors.blue[0],
      }}
    >
      <Flex
        direction={{ base: "column", sm: "row" }}
        align="center"
        justify="space-between"
        wrap="wrap"
        gap="md"
      >
        <Group spacing="xs" align="center">
          <IconMail color={theme.colors.blue[6]} size={20} />
          <Text size="sm" color={theme.colors.blue[7]}>
            <Anchor href="mailto:healthconnect@mindbowser.com" target="_blank">
              healthconnect@mindbowser.com
            </Anchor>
          </Text>
        </Group>

        <Group spacing="xs" align="center">
          <IconWorld color={theme.colors.blue[6]} size={20} />
          <Text
            sx={{
              cursor: "pointer",
              textDecoration: "none",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
            size="sm"
            color={theme.colors.blue[7]}
            onClick={() => {
              window.open("https://healthconnect.mindbowser.com/", "_blank");
            }}
          >
            healthconnect.mindbowser.com
          </Text>
        </Group>

        <Text size="sm" color={theme.colors.blue[7]}>
          © 2024 Mindbowser Inc. All rights reserved.
        </Text>
      </Flex>
    </Box>
  );
};

export default Footer;
